// @flow
import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import {
  paragraphStyles,
  type ParagraphSizes,
} from '@rover/design-system/style-dictionary/build/es6/theme';

import {
  margin,
  type MarginProps,
  textAlign,
  type TextAlignProps,
  textColor,
  type TextColorProps,
  fontWeight,
  type FontWeightProps,
} from '@rover/react-lib/styles/styled-system';

export type Props = {
  ...MarginProps,
  ...TextAlignProps,
  ...TextColorProps,
  ...FontWeightProps,
  size: ParagraphSizes,
  children: Node,
  maxWidth: string,
};

const StyledParagraph: StyledComponent<Props> = styled.p`
  padding: 0;
  margin: 0;
  border: 0 none;
  ${({ size }) => paragraphStyles[size]}
  max-width: ${props => props.maxWidth};
  ${margin}
  ${textAlign}
  ${textColor}
  ${fontWeight}
`;

const Paragraph = (props: Props) => <StyledParagraph {...props} />;

Paragraph.defaultProps = {
  size: '200',
  maxWidth: '640px', // reasoning behind this default is at https://www.rover.com/design-system/components/paragraph/guidelines/#content-guidelines
};

export default Paragraph;



// WEBPACK FOOTER //
// ../react-lib/src/components/typography/Paragraph/Paragraph.jsx